<!--
	ServiceReadFields.svelte

    8/16 - replace field-pairs with FieldGroups and DataFields

    This component displays the many fields of a Service.
    Set up as two blocks L/R which will stack in mobile views.
    These fields are read-only for display.

    Service JSON as of 10/26/2022:

    {
        additionalInformation
        addressLine1
        availability
        city
        costFreeText
        country
        county
        coverageAreas
        coverageCounties
        coverageGranularity
        coveragePostalCodes
        createdAt

        description
        eligibility
        formattedAddress
        geoId
        googleBusinessLink
        googleNumberRatings
        googleRating
        googleTestimonials
        id
        insuranceAccepted
        lastValidated
        lat
        locationPrecision
        lon

        mainEmail
        mainFacebook
        mainFax
        mainPhone
        mainTwitter
        mainWebsite
        minerNotes
        necessaryDocuments
        necessaryMaterials
        nextSteps
        operatingHours
        otherSocialMedia
        postalCode
        reviewed
        serviceName
        source
        state
        supportedInsurance
        supportedLanguages
        taxonomies
        updatedAt
        virtual
    }

-->

<script>
    import { onMount } from 'svelte';
    import { AccountStore } from "../../common/account";

    // TCARE components
    import TaxonomyFieldsGroup from '../field-groups/TaxonomyFieldsGroup.svelte';
    import ServiceFieldsGroup1 from '../field-groups/ServiceFieldsGroup1.svelte';
    import ServiceFieldsGroup2 from '../field-groups/ServiceFieldsGroup2.svelte';
    import ServiceFieldsGroup3 from '../field-groups/ServiceFieldsGroup3.svelte';
    import ServiceFieldsGroup4 from '../field-groups/ServiceFieldsGroup4.svelte';
    import ServiceFieldsGroup6Stats from '../field-groups/ServiceFieldsGroup6Stats.svelte';
    import ServiceFieldsGroup5Coverage from '../field-groups/ServiceFieldsGroup5Coverage.svelte';

    export let store;         // masterService object passed in from <ServiceDetailsPage>

    onMount(() => {
    })

</script>


<style>

	* :global(.label svg) {
		width: 20px !important;
		height: 20px !important;
		fill: var(--tcare-primary);
		outline: none;
	}
    
    :global(.panel-2-checkbox) {
        margin-left: -10px !important;
    }

    @media screen and (max-width: 600px) {
    }

    /*
    :global(.service-details-read-fields .data-taxonomy-field .value) {
        width: 86% !important;
    }
    */



    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>


<div class="service-details-read-fields tcare-form">
    <TaxonomyFieldsGroup
        store={store}
        leftService={null}
        rightService={null}
        onCopyTaxonomy={null}
        isEditable={false}
        isOpen={true}
        showTcareTax1={$AccountStore?.isLoggedIn}
        showDiffs={false}
    />

    <ServiceFieldsGroup1
        store={store}
        leftService={null}
        rightService={null}
        onCopyValue={null}
        isEditable={false}
        isOpen={true}
        showDiffs={false}
    />

    <ServiceFieldsGroup2
        store={store}
        leftService={null}
        rightService={null}
        onCopyValue={null}
        isEditable={false}
        isOpen={true}
        showDiffs={false}
    />

    <ServiceFieldsGroup3
        store={store}
        leftService={null}
        rightService={null}
        onCopyValue={null}
        isEditable={false}
        isOpen={true}
        showDiffs={false}
    />

    <ServiceFieldsGroup4
        store={store}
        leftService={null}
        rightService={null}
        onCopyValue={null}
        isEditable={false}
        isOpen={true}
        showDiffs={false}
    />

    <!--
    <ServiceFieldsGroup5Coverage
        store={store}
        leftService={null}
        rightService={null}
        onCopyValue={null}
        isEditable={false}
        isOpen={true}
        showDiffs={false}
    />

    <ServiceFieldsGroup6Stats
        store={store}
        leftService={null}
        rightService={null}
        onCopyValue={null}
        isEditable={false}
        isOpen={false}
        showDiffs={false}
    />
    -->

    <div class="spacer-h-10"></div>
</div>
